export enum EnumResources {
  All = 'All',
}

export enum EnumRole {
  Admin = 'Admin',
  All = 'All',
}

export enum ActionType {
  HIDE = 'HIDE',
  DISABLED = 'DISABLED',
  REPLACE = 'REPLACE',
}

export enum EInterceptorReject {
  reject = 'rejectByCheckingLogin',
}

export enum EResourcesPrefix {
  OWNER_SUFFIX = 'self',
}

export enum EResourcesAdmin {
  superAdmin = 'superAdmin',
  test = 'test',
}

export enum EPermissionSource {
  store = 'store',
  salesChannel = 'salesChannel',
}

export enum EnumCategory {
  SalesChannelProductCollection = 'SalesChannelProductCollection',
  SalesChannelMaintenancePage = 'SalesChannelMaintenancePage',
  SalesChannelDiscount = 'SalesChannelDiscount',
  SalesChannelContent = 'SalesChannelContent',
  SalesChannelLegal = 'SalesChannelLegal',
  SalesChannelCategory = 'SalesChannelCategory',
  SalesChannelProduct = 'SalesChannelProduct',
  SalesChannelSettings = 'SalesChannelSettings',
  SalesChannelGeneral = 'SalesChannelGeneral',

  Settings = 'Settings',
  Order = 'Order',
  Products = 'Products',
  Customers = 'Customers',
  General = 'SalesChannelGeneral',
  Voucher = 'Voucher',
  Communication = 'Communication',
  Analytics = 'Analytics',
  Dashboard = 'Dashboard', //新加的，在permission里面，dashboard属于Analytics
}

export enum EnumSalesChannelContentCategory {
  SalesChannelAppearanceEditorPage = 'SalesChannelAppearanceEditorPage',
  SalesChannelContentPageEditorPage = 'SalesChannelContentPageEditorPage',
  SalesChannelEditor404Page = 'SalesChannelEditor404Page',
  SalesChannelEditorAllProductPage = 'SalesChannelEditorAllProductPage',
  SalesChannelEditorAnimation = 'SalesChannelEditorAnimation',
  SalesChannelEditorButton = 'SalesChannelEditorButton',
  SalesChannelEditorContentPageList = 'SalesChannelEditorContentPageList',
  SalesChannelEditorFooter = 'SalesChannelEditorFooter',
  SalesChannelEditorHeader = 'SalesChannelEditorHeader',
  SalesChannelEditorHomepage = 'SalesChannelEditorHomepage',
  SalesChannelEditorMegaMenu = 'SalesChannelEditorMegaMenu',
  SalesChannelEditorNavigation = 'SalesChannelEditorNavigation',
  SalesChannelEditorProductSearch = 'SalesChannelEditorProductSearch',
  SalesChannelEditorProfilePage = 'SalesChannelEditorProfilePage',
  SalesChannelEditorPromotion = 'SalesChannelEditorPromotion',
  SalesChannelEditorShoppingCartPage = 'SalesChannelEditorShoppingCartPage',
  SalesChannelEditorTabbar = 'SalesChannelEditorTabbar',
  SalesChannelEditorText = 'SalesChannelEditorText',
}

export enum EnumSubCategory {
  'AllOrders' = 'AllOrders',
  'ChannelCheckout' = 'ChannelCheckout',
  'ChannelCommunication' = 'ChannelCommunication',
  'ChannelContent' = 'ChannelContent',
  'ChannelCookies' = 'ChannelCookies',
  'ChannelCurrency' = 'ChannelCurrency',
  'ChannelDigitalMarketing' = 'ChannelDigitalMarketing',
  'ChannelDiscount' = 'ChannelDiscount',
  'ChannelDomainAndStatus' = 'ChannelDomainAndStatus',
  'ChannelGeneral' = 'ChannelGeneral',
  'ChannelInventory' = 'ChannelInventory',
  'ChannelInvoice' = 'ChannelInvoice',
  'ChannelLanguage' = 'ChannelLanguage',
  'ChannelLegal' = 'ChannelLegal',
  'ChannelLocalisation' = 'ChannelLocalisation',
  'ChannelLogistics' = 'ChannelLogistics',
  'ChannelLogoManagement' = 'ChannelLogoManagement',
  'ChannelMaintenancePage' = 'ChannelMaintenancePage',
  'ChannelMiniProgramSetting' = 'ChannelMiniProgramSetting',
  'ChannelOrder' = 'ChannelOrder',
  'ChannelPayment' = 'ChannelPayment',
  'ChannelProduct' = 'ChannelProduct',
  'ChannelProductCategory' = 'ChannelProductCategory',
  'ChannelProductCollection' = 'ChannelProductCollection',
  'ChannelRegistration' = 'ChannelRegistration',
  'ChannelTax' = 'ChannelTax',
  'CustomerDatabaseGeneral' = 'CustomerDatabaseGeneral',
  'CustomerDatabaseSetting' = 'CustomerDatabaseSetting',
  'CustomerDetailsPage' = 'CustomerDetailsPage',
  'CustomerGeneral' = 'CustomerGeneral',
  'CustomerTagDetailsPage' = 'CustomerTagDetailsPage',
  'CustomerTagGeneral' = 'CustomerTagGeneral',
  'OrderAdditionalItem' = 'OrderAdditionalItem',
  'OrderAdditionalPromoCode' = 'OrderAdditionalPromoCode',
  'OrderCancellation' = 'OrderCancellation',
  'OrderCartTemplate' = 'OrderCartTemplate',
  'OrderCreation' = 'OrderCreation',
  'OrderCustomer' = 'OrderCustomer',
  'OrderFulfillment' = 'OrderFulfillment',
  'OrderGiftCard' = 'OrderGiftCard',
  'OrderPayment' = 'OrderPayment',
  'OrderRefund' = 'OrderRefund',
  'OrderReturn' = 'OrderReturn',
  'OrderSubscription' = 'OrderSubscription',
  'Products' = 'Products',
  'ProductsInventory' = 'ProductsInventory',
  'ProductsReview' = 'ProductsReview',
  'ProductsStockIn' = 'ProductsStockIn',
  'SettingsCommunication' = 'SettingsCommunication',
  'SettingsCurrency' = 'SettingsCurrency',
  'SettingsDeveloperSetting' = 'SettingsDeveloperSetting',
  'SettingsFileLibrary' = 'SettingsFileLibrary',
  'SettingsInvoice' = 'SettingsInvoice',
  'SettingsLinkLibrary' = 'SettingsLinkLibrary',
  'SettingsLocalisation' = 'SettingsLocalisation',
  'SettingsLogistics' = 'SettingsLogistics',
  'SettingsLogisticsAllLogisticsSettings' = 'SettingsLogisticsAllLogisticsSettings',
  'SettingsLogisticsDestinationAddressLocalisation' = 'SettingsLogisticsDestinationAddressLocalisation',
  'SettingsLogisticsPickupLocations' = 'SettingsLogisticsPickupLocations',
  'SettingsLogisticsShippingZone' = 'SettingsLogisticsShippingZone',
  'SettingsLogisticsWarehouse' = 'SettingsLogisticsWarehouse',
  'SettingsOrder' = 'SettingsOrder',
  'SettingsPayment' = 'SettingsPayment',
  'SettingsProduct' = 'SettingsProduct',
  'SettingsStoreDetails' = 'SettingsStoreDetails',
  'SettingsStoreTagManager' = 'SettingsStoreTagManager',
  'SettingsTaxes' = 'SettingsTaxes',
  'SettingsThirdParty' = 'SettingsThirdParty',
  'SettingsUserPermission' = 'SettingsUserPermission',
  'SettingsView' = 'SettingsView',
  'StoreChannel' = 'StoreChannel',
  'StoreVoucher' = 'StoreVoucher',
  SettingsLogisticsPackages = 'SettingsLogisticsPackages',
  CommunicationAuditTrail = 'CommunicationAuditTrail',
  AnalyticsDashboard = 'AnalyticsDashboard',
  AnalyticsReportSubscription = 'AnalyticsReportSubscription',
  AnalyticsReports = 'AnalyticsReports',
}

export enum EnumOperation {
  'access_page_and_view' = 'access_page_and_view',
  access_page_and_view_customer_details_page = 'access_page_and_view_customer_details_page',
  'add' = 'add',
  'add_customer' = 'add_customer',
  'add_edit_T_C' = 'add_edit_T_C',
  'add_edit_category' = 'add_edit_category',
  'add_edit_click_and_collect_pickup_location' = 'add_edit_click_and_collect_pickup_location',
  'add_edit_communication_gateway' = 'add_edit_communication_gateway',
  'add_edit_courier_account_parcel_locker_delivery_method' = 'add_edit_courier_account_parcel_locker_delivery_method',
  'add_edit_discount' = 'add_edit_discount',
  'add_edit_legal_page' = 'add_edit_legal_page',
  'add_edit_packages' = 'add_edit_packages',
  'add_edit_payment_gateway' = 'add_edit_payment_gateway',
  'add_edit_product' = 'add_edit_product',
  'add_edit_product_collection' = 'add_edit_product_collection',
  'add_edit_promotion_tag' = 'add_edit_promotion_tag',
  'add_edit_review' = 'add_edit_review',
  'add_edit_shipping_zone' = 'add_edit_shipping_zone',
  'add_edit_tag' = 'add_edit_tag',
  'add_edit_tax_rule' = 'add_edit_tax_rule',
  'add_edit_template' = 'add_edit_template',
  'add_edit_user' = 'add_edit_user',
  'add_edit_voucher' = 'add_edit_voucher',
  'add_edit_warehouse_information' = 'add_edit_warehouse_information',
  'add_stock' = 'add_stock',
  'add_tag' = 'add_tag',
  'approve' = 'approve',
  'archive_T_C' = 'archive_T_C',
  'archive_discount' = 'archive_discount',
  'archive_legal_page' = 'archive_legal_page',
  'archive_publish_unpublish' = 'archive_publish_unpublish',
  'cancel_order' = 'cancel_order',
  'cancel_subscription' = 'cancel_subscription',
  'confirm_refund' = 'confirm_refund',
  'copy_webhook' = 'copy_webhook',
  'create_access_key' = 'create_access_key',
  'create_database' = 'create_database',
  'create_duplicate_edit_draft_content_version' = 'create_duplicate_edit_draft_content_version',
  'create_duplicate_edit_live_content_version' = 'create_duplicate_edit_live_content_version',
  'create_duplicate_sales_channel' = 'create_duplicate_sales_channel',
  'create_edit_link' = 'create_edit_link',
  'create_edit_order' = 'create_edit_order',
  'create_edit_refund' = 'create_edit_refund',
  'create_edit_request' = 'create_edit_request',
  'create_edit_return' = 'create_edit_return',
  'create_edit_shopping_cart_template' = 'create_edit_shopping_cart_template',
  'customise_packing_slip' = 'customise_packing_slip',
  'deactivate_warehouse' = 'deactivate_warehouse',
  'delete_access_key' = 'delete_access_key',
  'delete_category' = 'delete_category',
  'delete_click_and_collect_pickup_location' = 'delete_click_and_collect_pickup_location',
  'delete_communication_gateway' = 'delete_communication_gateway',
  'delete_file' = 'delete_file',
  'delete_link' = 'delete_link',
  'delete_order_portal_created_order' = 'delete_order_portal_created_order',
  'delete_packages' = 'delete_packages',
  'delete_payment_gateway' = 'delete_payment_gateway',
  'delete_product' = 'delete_product',
  'delete_product_collection' = 'delete_product_collection',
  'delete_promotion_tag' = 'delete_promotion_tag',
  'delete_review' = 'delete_review',
  'delete_sales_channel' = 'delete_sales_channel',
  'delete_shipping_zone' = 'delete_shipping_zone',
  'delete_shopping_cart_template' = 'delete_shopping_cart_template',
  'delete_subscription' = 'delete_subscription',
  'delete_tag' = 'delete_tag',
  'delete_tax_rule' = 'delete_tax_rule',
  'delete_template' = 'delete_template',
  'delete_version' = 'delete_version',
  'edit_and_save' = 'edit_and_save',
  'edit_customer' = 'edit_customer',
  'edit_customer_info' = 'edit_customer_info',
  'edit_destinationaddress_localisation_setting' = 'edit_destinationaddress_localisation_setting',
  'edit_email_mobile' = 'edit_email_mobile',
  'edit_inventory' = 'edit_inventory',
  'edit_maintencance_page' = 'edit_maintencance_page',
  'edit_quantity' = 'edit_quantity',
  'edit_setting' = 'edit_setting',
  'edit_setting_preview_test_invoice_print_test_invoice' = 'edit_setting_preview_test_invoice_print_test_invoice',
  'edit_tag' = 'edit_tag',
  'erase_customer_data' = 'erase_customer_data',
  'mark_as_paid_bank_transfer_' = 'mark_as_paid_bank_transfer_',
  'mark_as_refunded' = 'mark_as_refunded',
  'mark_as_returned' = 'mark_as_returned',
  'notify_customer' = 'notify_customer',
  'null' = 'null',
  'pick_pack_process_settings' = 'pick_pack_process_settings',
  'pick_pack_ship' = 'pick_pack_ship',
  'click_collect' = 'click_collect',
  'place_order' = 'place_order',
  'preview_test_packing_slip' = 'preview_test_packing_slip',
  'publish_unpublish_archive' = 'publish_unpublish_archive',
  'publish_unpublish_version' = 'publish_unpublish_version',
  'reject' = 'reject',
  'remove' = 'remove',
  'rename_database' = 'rename_database',
  'rename_sales_channel' = 'rename_sales_channel',
  'reply_review' = 'reply_review',
  'resend_notification' = 'resend_notification',
  'send_account_invite' = 'send_account_invite',
  'subscribe_customer' = 'subscribe_customer',
  'switch_status' = 'switch_status',
  'upload_and_edit_file' = 'upload_and_edit_file',
  'view_all_customer_database_listing_page' = 'view_all_customer_database_listing_page',
  'view_all_customers_listing_page' = 'view_all_customers_listing_page',
  'view_all_logistics_settings_page' = 'view_all_logistics_settings_page',
  'view_all_orders_listing_page' = 'view_all_orders_listing_page',
  'view_all_product_listing_page' = 'view_all_product_listing_page',
  'view_all_product_review_listing_page' = 'view_all_product_review_listing_page',
  'view_all_sales_channel_listing_page' = 'view_all_sales_channel_listing_page',
  'view_all_settings_page' = 'view_all_settings_page',
  'view_all_tax_rule_listing_page' = 'view_all_tax_rule_listing_page',
  'view_click_and_collect_pickup_location_details' = 'view_click_and_collect_pickup_location_details',
  'view_communication_gateway_details_page' = 'view_communication_gateway_details_page',
  'view_communication_gateways_listing_page' = 'view_communication_gateways_listing_page',
  'view_courier_account_setting_page' = 'view_courier_account_setting_page',
  'view_currency_setting' = 'view_currency_setting',
  'view_delivery_method_setting_page' = 'view_delivery_method_setting_page',
  'view_destinationaddress_localisation_setting' = 'view_destinationaddress_localisation_setting',
  'view_developer_setting' = 'view_developer_setting',
  'view_edit_customer_info' = 'view_edit_customer_info',
  'view_file_details' = 'view_file_details',
  'view_file_library_listing_page' = 'view_file_library_listing_page',
  'view_gift_card_store_credit_details_page' = 'view_gift_card_store_credit_details_page',
  'view_gift_card_store_credit_listing_page' = 'view_gift_card_store_credit_listing_page',
  'view_inventory_history' = 'view_inventory_history',
  'view_inventory_listing_page' = 'view_inventory_listing_page',
  'view_invoice_details' = 'view_invoice_details',
  'view_link_details' = 'view_link_details',
  'view_link_library_listing_page' = 'view_link_library_listing_page',
  'view_order_details_page' = 'view_order_details_page',
  'view_order_setting' = 'view_order_setting',
  'view_packages_details' = 'view_packages_details',
  'view_packing_slip_setting_page' = 'view_packing_slip_setting_page',
  'view_parcel_lockers_setting_page' = 'view_parcel_lockers_setting_page',
  'view_payment_gateway_details' = 'view_payment_gateway_details',
  'view_payment_gateways_listing_page' = 'view_payment_gateways_listing_page',
  'view_product_details_page' = 'view_product_details_page',
  'view_product_setting' = 'view_product_setting',
  'view_settings' = 'view_settings',
  'view_shopping_cart_template_details_page' = 'view_shopping_cart_template_details_page',
  'view_shopping_cart_template_listing_page' = 'view_shopping_cart_template_listing_page',
  'view_stock_details' = 'view_stock_details',
  'view_stock_listing_page' = 'view_stock_listing_page',
  'view_store_details' = 'view_store_details',
  'view_store_tags' = 'view_store_tags',
  'view_subscription_buy_details_page' = 'view_subscription_buy_details_page',
  'view_subscription_buy_listing_page' = 'view_subscription_buy_listing_page',
  'view_tax_rule_details' = 'view_tax_rule_details',
  'view_voucher_details_page' = 'view_voucher_details_page',
  'view_voucher_listing_page' = 'view_voucher_listing_page',
  'view_warehouse_setting_page' = 'view_warehouse_setting_page',
  view_customer_database_settings = 'view_customer_database_settings',
  view_customer_tags_listing_page = 'view_customer_tags_listing_page',
  view_customer_tag_details_page = 'view_customer_tag_details_page',
  mark_as_paid_bank_transfer = 'mark_as_paid_bank_transfer',
  mark_as_paid_manual = 'mark_as_paid_manual',
  process_refund = 'process_refund',
  edit_pick_pack_process_settings = 'edit_pick_pack_process_settings',
  view_communication_audit_trail_listing_page = 'view_communication_audit_trail_listing_page',
  view_communication_audit_trail_details_page = 'view_communication_audit_trail_details_page',
  view_dashboard = 'view_dashboard',
  view_report_subscription_listing_page = 'view_report_subscription_listing_page',
  view_report_subscription_details_page = 'view_report_subscription_details_page',
  add_edit_report_subscription = 'add_edit_report_subscription',
  delete_report_subscription = 'delete_report_subscription',
  view_report_listing_page = 'view_report_listing_page',
  view_report_details_page = 'view_report_details_page',
  add_edit_report = 'add_edit_report',
  delete_report = 'delete_report',
  view_content_version_listing_page = 'view_content_version_listing_page',
  view_content_version_details = 'view_content_version_details',
  view_all_products_listing_page = 'view_all_products_listing_page',
  view_all_promotion_tags_listing_page = 'view_all_promotion_tags_listing_page',
  view_promotion_tag_details_page = 'view_promotion_tag_details_page',
  view_maintenance_page = 'view_maintenance_page',
  edit_maintenance_page = 'edit_maintenance_page',
  view_all_collections_listing_page = 'view_all_collections_listing_page',
  view_collection_details_page = 'view_collection_details_page',
  view_category_page = 'view_category_page',
  view_all_legal_page_listing_page = 'view_all_legal_page_listing_page',
  view_legal_page_details = 'view_legal_page_details',
  view_all_T_C_listing_page = 'view_all_T_C_listing_page',
  view_T_C_details_page = 'view_T_C_details_page',
  view_all_discounts_listing_page = 'view_all_discounts_listing_page',
  view_discount_details_page = 'view_discount_details_page',
  view_invoice_settings = 'view_invoice_settings',
  view_digital_marketing_settings = 'view_digital_marketing_settings',
  view_logistic_setting = 'view_logistic_setting',
  view_localisation_setting = 'view_localisation_setting',
  view_inventory_setting = 'view_inventory_setting',
  view_language_setting = 'view_language_setting',

  view_coolies_setting = 'view_coolies_setting',
  view_payment_settings = 'view_payment_settings',
  view_checkout_settings = 'view_checkout_settings',
  view_registration_settings = 'view_registration_settings',
  view_logo_management_settings = 'view_logo_management_settings',
  view_domain_and_status = 'view_domain_and_status',
  view_Mini_program_settings = 'view_Mini_program_settings',
  view_tax_settings = 'view_tax_settings',
  view_communication_settings = 'view_communication_settings',
  edit_invoice_settings = 'edit_invoice_settings',
  edit_digital_marketing_settings = 'edit_digital_marketing_settings',
  edit_currency_settings = 'edit_currency_settings',
  edit_logistics_setting = 'edit_logistics_setting',
  edit_localisation_setting = 'edit_localisation_setting',
  edit_inventory_setting = 'edit_inventory_setting',
  edit_language_setting = 'edit_language_setting',
  edit_order_setting = 'edit_order_setting',
  edit_cookies_settings = 'edit_cookies_settings',
  edit_payment_setting = 'edit_payment_setting',
  edit_checkout_setting = 'edit_checkout_setting',
  edit_registration_setting = 'edit_registration_setting',
  edit_logo_management = 'edit_logo_management',
  edit_domain_and_status = 'edit_domain_and_status',
  edit_Mini_program_setting = 'edit_Mini_program_setting',
  edit_tax_setting = 'edit_tax_setting',
  edit_communication_setting = 'edit_communication_setting',
}

export interface IQueryStoreResourceParams {
  category: EnumCategory;
  subCategory: EnumSubCategory;
  operation: EnumOperation;
  isSelf?: boolean;
}

export interface IQuerySalesChannelResourceParams
  extends IQueryStoreResourceParams {
  uuid: string;
}
